import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getTypedStudyAdapter} from 'studies/typed/TypedStudyAdapters';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

interface ProcedureBasedStudyAnalysisModalBannerProps {
  studyType: StudyType;
}

/**
 * Informational banner to display in the analysis generation modal for procedure-based studies.
 */
export default function ProcedureBasedStudyAnalysisModalBanner(
  props: ProcedureBasedStudyAnalysisModalBannerProps
): JSX.Element {
  const {studyType} = props;
  const typedStudyAdapter = getTypedStudyAdapter(studyType);
  const datasetTypesText = typedStudyAdapter.isUnitOperationInstanceLinkingEnabled
    ? 'parameters, conditions, unit operation links, registered entities, and results.'
    : 'parameters, conditions, registered entities, and results.';
  const bannerText = `Datasets will be automatically generated based on your ${datasetTypesText}`;
  return (
    <div className={css(styles.banner)}>
      <InlineBanner bannerType={InlineBannerType.INFO} text={bannerText} />
    </div>
  );
}

const styles = StyleSheet.create({
  banner: {
    paddingBottom: '10px',
  },
});
